var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uptec-iframe-layout" }, [
    _c(
      "div",
      { staticClass: "container iframe-container" },
      [
        _vm.iframeUrl
          ? _c("div", { staticClass: "grid" }, [
              _c("iframe", {
                key: _vm.uptecIframeKey,
                attrs: {
                  "qa-iframe-uptec": "",
                  width: "100%",
                  height: "100%",
                  src: _vm.iframeUrl
                }
              })
            ])
          : _c("ma-empty", {
              attrs: {
                "qa-empty-iframe": "",
                icon: "recherche",
                title: _vm.$t("furniture.empty.short"),
                descr: _vm.$t("furniture.empty.long")
              }
            })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }